import React from "react";
import { t, businessName, itemName, customerMobile } from "./invoiceTemplate.shared";
import { InvoiceBrandMark, InvoiceSignature } from "./InvoiceBrandAssets";
import "./ThermalInvoiceTemplate.css";

const ThermalInvoiceTemplate = ({
  invoice,
  invoiceNumber,
  businessSnapshot,
  customerName,
  customerSnapshot,
  billingAddress,
  shippingAddress,
  calculatedItems = [],
  totals = {},
  grandTotal = 0,
  paidAmount = 0,
  balanceAmount = 0,
  displayCurrency,
  formatAddress,
  formatDate,
  formatLabel,
  formatNumber,
  numberToWords,
}) => (
  <section className="invoice-thermal">
    <header><InvoiceBrandMark businessSnapshot={businessSnapshot} compact /><h1>{businessName(businessSnapshot)}</h1><p>{formatAddress(businessSnapshot?.address || businessSnapshot)}</p><p>GSTIN: {t(businessSnapshot?.gstin)}</p><p>Ph: {t(businessSnapshot?.mobile)}</p></header>
    <hr/>
    <div className="invoice-thermal__meta"><span>Invoice <b>{invoiceNumber}</b></span><span>Date <b>{formatDate(invoice?.documentDate)}</b></span><span>Customer <b>{customerName}</b></span><span>Mobile <b>{customerMobile(customerSnapshot, invoice)}</b></span></div>
    <hr/>
    <div className="invoice-thermal__row head"><b>ITEM</b><b>QTY</b><b>AMOUNT</b></div>
    {calculatedItems.map((item,index)=><div className="invoice-thermal__row" key={item?._id || index}><div><b>{index+1}. {itemName(item)}</b><small>{displayCurrency(item?.calculation?.rate)} × {formatNumber(item?.calculation?.quantity,0,2)}</small></div><span>{formatNumber(item?.calculation?.quantity,0,2)}</span><b>{displayCurrency(item?.calculation?.totalAmount)}</b></div>)}
    <hr/>
    <div className="invoice-thermal__totals"><span>TOTAL <b>{displayCurrency(grandTotal)}</b></span><span>PAID <b>{displayCurrency(paidAmount)}</b></span><span>BALANCE <b>{displayCurrency(balanceAmount)}</b></span></div>
    <hr/><footer><b>THANK YOU</b><span>Visit Again</span><InvoiceSignature businessSnapshot={businessSnapshot} /><small>Computer generated invoice</small></footer>
  </section>
);

export default ThermalInvoiceTemplate;
